import StoneDeviceList from '@/components/Settings/Stone/StoneDeviceList';
import { StoneAccount } from '@/core/domain/stone/stoneAccount/stoneAccount.types';
import { Modal } from 'antd';

interface Props {
  open: boolean;
  onClose: VoidFunction;
  stoneAccount?: StoneAccount;
}

export default function StoneAccountDevicesModal(props: Props) {
  function handleClose() {
    props.onClose();
  }

  return (
    <Modal
      open={props.open}
      onCancel={handleClose}
      title={`Maquinas da conta Stone - ${props.stoneAccount?.accountId}`}
      cancelText="Fechar"
      okButtonProps={{ style: { display: 'none' } }}
      width={700}
      maskClosable={false}
    >
      <StoneDeviceList stoneAccount={props.stoneAccount} />
    </Modal>
  );
}
